import Alpine from 'alpinejs'

Alpine.data('loginForm', (
    textEmailEmpty,
    textPasswordEmpty,
    textLoginInvalid
) => ({

    email: '',
    password: '',
    autoLogin: true,

    passwordType: 'password',
    disabled: false,

    emailInvalidMessage: null,
    passwordInvalidMessage: null,

    init() {
        // revert invalid state once user types again
        this.$watch('email', (email) => {
            if(this.emailInvalidMessage && email !== '') {
                this.emailInvalidMessage = null
            }
        })
        this.$watch('password', (password) => {
            if(this.passwordInvalidMessage && password !== '') {
                this.passwordInvalidMessage = null
            }
        })
    },

    login() {
        if(this.email === '') {
            this.emailInvalidMessage = textEmailEmpty
        }
        if(this.password === '') {
            this.passwordInvalidMessage = textPasswordEmpty
        }
        if(this.emailInvalidMessage || this.passwordInvalidMessage) {
            return
        }
        this.disabled = true
        this.$store.session.login(
            this.email,
            this.password,
            this.autoLogin
        ).then(() => {
            this.password = ''
            if(this.$store.session.authenticated) {
                this.email = ''
                this.emailInvalidMessage = null
                this.passwordInvalidMessage = null
            } else {
                this.emailInvalidMessage = textLoginInvalid
                this.passwordInvalidMessage = textLoginInvalid
            }
            this.disabled = false
        })
    },

    togglePasswordClearText() {
        if(this.passwordType === 'password') {
            this.passwordType = 'text'
        } else {
            this.passwordType = 'password'
        }
    }

}))